const record = {
  path: 'record',
  component: resolve => require(['../../../../pages/teacher/videoplay/record'], resolve)
}

export default record



// WEBPACK FOOTER //
// ./src/router/teacher/videoplay/record/index.js